import React, { useState ,useEffect } from 'react';

//src image
import banner from '../img/banner.png';
import logo from '../img/mulogo.png';

//css
import '../css/index.css';

//local store
import { useDispatch} from 'react-redux'
import { connect } from "react-redux";

//Useraction

import { useNavigate } from 'react-router-dom';
import { RiLogoutBoxLine ,RiCheckboxCircleFill,RiCloseCircleFill} from "react-icons/ri";
import { matchRoutes, useLocation } from "react-router-dom"
import Header from './header/Header';
import NavBtn from '../Nav/NavBtn';
import { Image } from '../img';
import {Utility} from '../Utility/Utility';

// import { RiLogoutBoxLine } from "react-icons/ri";

const TeachingTools = (props) => {
    const currentLocation = useLocation();
    
    const dispatch=useDispatch();
    
    const navigate = useNavigate();
    const matches = matchRoutes(Utility.routes, currentLocation);
    console.log('matches',matches)
    const rightIconAry=[
        {
            icon:'How_dark',
            label: 'How to access OLE',
            path:'/how_to_access_ole',
        },
        {
            icon:'Dashboard_light',
            label: 'Dashboard',
            path:'/ashboard'
        },
        {
            icon:'Course_light',
            label: 'Course Page',
            path:'/course_page',
        },
        {
            icon:'Attendance_light',
            label: 'Taking Attendance',
            path:'/taking_attendance'
        },
        {
            icon:'Assignment_light',
            label: 'Assignment',
            path:'/assignment',
        },
        {
            icon:'Zoom_light',
            label: 'Zoom Recording',
            path:'/zoom_recording',
        },
        {
            icon:'Teaching_light',
            label: 'Teaching Tools',
            path:'/teaching_tools',
        }
    ]


    return (
        <div className='MainContainer'>
            <Header/>
            <div className={'MainContent'}>
                <img className='MainContentFixBottomImageOnly' src={Image.inner_pages_bg1} alt='banner'/>
                <div className='MainContentFixBottomLine'></div>
                <div className={'MainContentBox'}>
                    <img className="MainContentTopImage" src={Image.Sub_teaching} alt='banner' />
                    <div className="MainContentTopContain">
                        <span className="MainContentTopText">Teaching Tools</span>
                    </div>
                    <div className={"MainContentMiddleDetail"} >
                        <div style={{verticalAlign: 'middle',display: 'table-cell'}}>
                            <p >To facilitate your teaching, the OLE provides several useful teaching tools such as Kahoot!, Mentimeter, and Blooket. Some of these tools require self-registration, while others are offered with limited licenses that require reservation at the beginning of each term.</p>
                            <p >
                                <span>
                                <a href={Image.Word.image070} data-lightbox="TeachingTools" >
                                <img border={0} width={350} height='auto' src={Image.Word.image070}/>
                                </a>
                                
                                </span>
                            </p>
                           
                            
                        </div>
                    </div>
                    <NavBtn prevItem='/zoom-recording' />
                </div>
                
            </div>
            
            
        </div>
    )
};
  

const mapStateToProps =(state)=> {
    const {userInfo}=state;
    return {
        userInfo
    }
}

// export default CoursePage;
export default connect(mapStateToProps)(TeachingTools);